module.exports = "https://cdn-challenge.mathletics.com/app/275/assets/images/27225403faa7cb949eeb6d1f3611edb7.gif";